var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-checkbox__container",on:{"click":_vm.toggle}},[_c('div',{staticClass:"c-checkbox",class:_vm.classes,attrs:{"checked":_vm.$data.checked}}),_vm._v(" "),_c('div',{staticClass:"title1"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }